import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Dropdown, Form, Input, Menu, Modal, Radio, Space } from "antd";

import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";
import { toastAlert } from "../AlertComponent";

import AddImportProductModal from "./AddImportProductModal";

const AddProductModal = ({
	modalShow,
	setModalShow,
	selectKey,
	type,
	selectProduct,
	productList,
	setProductList,
	index,
	level,
}) => {
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));
	const inputRef = useRef(null);

	const [importShow, setImportShow] = useState(false);

	// const [photo, setPhoto] = useState({});
	const [imgSrc, setImgSrc] = useState("/assets/images/channel/img-add.png");

	const platformName = ["iHerb", "쿠팡", "셀로맥스", "당신의 영양제"];
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	const [ingredientList, setIngredientList] = useState([]);
	const [ingredientProductList, setIngredientProductList] = useState([]);
	const [categoryName, setCategoryName] = useState("");
	const [productInfo, setProductInfo] = useState({
		category_id: "",
		category_name: "",
		brand_name: "",
		product_name: "",
		sub_title: "",
		descriptionList: [],
		purchaseList: [
			{
				type: "",
				url: "",
				discount_code: "",
			},
			{
				type: "",
				url: "",
				discount_code: "",
			},
		],
		search_tag: "",
		img_type: null,
	});

	const dropdownCategory = (
		<Menu>
			{ingredientList?.map((item, idx) => (
				<Menu.Item
					key={`${item.ingredient_id} ${idx}`}
					onClick={() => dropdownSelect(item, "category")}
				>
					{item.ingredient_name}
				</Menu.Item>
			))}
		</Menu>
	);

	const dropdownProduct = (
		<Menu>
			{ingredientProductList?.map((item) => (
				<Menu.Item
					key={`${item.id}`}
					onClick={() => dropdownSelect(item, "product")}
				>
					{item.product_name}
				</Menu.Item>
			))}
		</Menu>
	);

	function dropdownSelect(item, type) {
		if (type === "category") {
			setProductInfo({
				category_id: item.ingredient_id,
				category_name: item.ingredient_name,
				brand_name: "",
				product_name: "",
				sub_title: "",
				descriptionList: [],
				purchaseList: [
					{
						type: "",
						url: "",
						discount_code: "",
					},
					{
						type: "",
						url: "",
						discount_code: "",
					},
				], // type, url, discount_code
				search_tag: "",
				img_type: null,
			});
			setImgSrc("/assets/images/channel/img-add.png");
		} else {
			let descriptions = [
				item?.description1 ? item.description1 : "",
				item?.description2 ? item.description2 : "",
				item?.description3 ? item.description3 : "",
				item?.description4 ? item.description4 : "",
				item?.description5 ? item.description5 : "",
				item?.description6 ? item.description6 : "",
			];
			let purchases = [0, 1].map((arr, idx) => {
				let link = item?.purchaseLinkList?.[idx];
				if (link) {
					return {
						type: link?.platform_id ? link.platform_id : "",
						url: link?.url ? link.url : "",
						discount_code: link?.discount_code ? link.discount_code : "",
					};
				} else {
					return {
						type: "",
						url: "",
						discount_code: "",
					};
				}
			});
			setProductInfo({
				...productInfo,
				...item,
				category_id: productInfo.category_id,
				category_name: productInfo.category_name,
				descriptionList: descriptions,
				purchaseList: purchases,
			});
			if (item.id && item.img_type) {
				setImgSrc(
					`${process.env.REACT_APP_S3_HOST}/image/together/${reduxChannel?.influencer_id}/${item.id}.${item?.img_type}`
				);
			} else {
				setImgSrc("/assets/images/channel/img-add.png");
			}
		}
	}

	useEffect(() => {
		if (level === "combination") {
			readCombinationProductList();
		}
	}, [level]);

	useEffect(() => {
		if (level === "combination") {
			if (productInfo.category_id && productInfo.category_name) {
				let categoryList = ingredientList.filter(
					(item) => item.ingredient_id === productInfo.category_id
				);
				let productList = categoryList[0]?.productList;
				if (productInfo.category_id) {
					setIngredientProductList(productList ? productList : []);
				} else {
					setIngredientProductList([]);
				}
			}
		}
	}, [level, productInfo]);

	useEffect(() => {
		if (type === "add") {
			setImgSrc("/assets/images/channel/img-add.png");
		} else {
			if (selectProduct.front_img_src) {
				setImgSrc(selectProduct.front_img_src);
			} else {
				if (selectProduct?.target_id) {
					setImgSrc(
						`${process.env.REACT_APP_S3_HOST}/image/recommend/${selectProduct?.target_id}.jpg`
					);
				} else {
					if (selectProduct?.id && selectProduct?.img_type) {
						setImgSrc(
							`${process.env.REACT_APP_S3_HOST}/image/together/${user?.influencer_id}/${selectProduct?.id}.${selectProduct?.img_type}`
						);
					}
				}
			}
		}
	}, [reduxChannel, selectProduct, type]);

	useEffect(() => {
		if (type === "edit" && selectProduct && selectKey?.ingredient_id) {
			let linkList = [];
			if (selectProduct?.purchaseLinkList?.length > 0) {
				selectProduct?.purchaseLinkList.map((item) => {
					let param = {
						id: item.id,
						type: String(item.platform_id),
						url: item.url,
						discount_code: item?.discount_code,
					};
					linkList.push(param);
				});
			}
			setProductInfo({
				category_id: selectKey.ingredient_id,
				category_name: selectKey.ingredient_name,
				brand_name: selectProduct.brand_name,
				product_name: selectProduct.product_name,
				sub_title: selectProduct.sub_title,
				descriptionList: [
					selectProduct.description1,
					selectProduct.description2,
					selectProduct.description3,
					selectProduct.description4,
					selectProduct.description5,
					selectProduct.description6,
				],
				purchaseList: [...linkList], // type, url, discount_code
				search_tag: selectProduct.search_tag,
				img_type: selectProduct.img_type,
				front_img_src: selectProduct?.front_img_src,
				photo: selectProduct?.photo,
			});
		} else if (type === "add" && selectProduct && selectKey?.ingredient_id) {
			setProductInfo({
				category_id: selectKey.ingredient_id,
				category_name: selectKey.ingredient_name,
				brand_name: "",
				product_name: "",
				sub_title: "",
				descriptionList: [],
				purchaseList: [
					{
						type: "",
						url: "",
						discount_code: "",
					},
					{
						type: "",
						url: "",
						discount_code: "",
					},
				], // type, url, discount_code
				search_tag: "",
				img_type: null,
			});
		}

		if (selectKey?.ingredient_id) {
			setCategoryName(selectKey?.ingredient_name);
		} else {
			setCategoryName(selectKey?.category_name ?? "");

			if (level === "combination") {
				if (type === "add") {
					setProductInfo({
						category_id: "",
						category_name: "",
						brand_name: "",
						product_name: "",
						sub_title: "",
						descriptionList: [],
						purchaseList: [
							{
								type: "",
								url: "",
								discount_code: "",
							},
							{
								type: "",
								url: "",
								discount_code: "",
							},
						], // type, url, discount_code
						search_tag: "",
						img_type: null,
					});
				} else {
					if (Object.keys(selectProduct).length > 0) {
						let linkList = [];
						if (selectProduct?.purchaseLinkList?.length > 0) {
							selectProduct?.purchaseLinkList.map((item) => {
								let param = {
									id: item.id,
									type: String(item.platform_id),
									url: item.url,
									discount_code: item?.discount_code,
								};
								linkList.push(param);
							});
						}
						setProductInfo({
							category_id: "",
							category_name: selectProduct?.category_name,
							brand_name: selectProduct.brand_name,
							product_name: selectProduct.product_name,
							sub_title: selectProduct.sub_title,
							descriptionList: [
								selectProduct.description1,
								selectProduct.description2,
								selectProduct.description3,
								selectProduct.description4,
								selectProduct.description5,
								selectProduct.description6,
							],
							purchaseList: [...linkList], // type, url, discount_code
							search_tag: selectProduct.search_tag,
							img_type: selectProduct.img_type,
							front_img_src: selectProduct?.front_img_src,
							photo: selectProduct?.photo,
						});
					}
				}
			}
		}
	}, [type, selectKey, selectProduct]);

	/**
	 * form 입력
	 * @param e
	 * @param idx
	 */
	const handleForm = (e, idx) => {
		if (e.target.name === "description") {
			let list = [...productInfo.descriptionList];
			list[idx] = e.target.value;
			setProductInfo({
				...productInfo,
				descriptionList: list,
			});
		} else if (e.target.name === "link-type") {
			let list = [...productInfo.purchaseList];
			list[idx] = {
				...list[idx],
				type: e.target.value,
			};
			setProductInfo({
				...productInfo,
				purchaseList: list,
			});
		} else if (e.target.name === "link-url") {
			let value = e.target.value;
			if (value.includes("https://")) {
				value = value.split("https://")[1];
			}
			const urlValue = "https://" + value;
			let list = [...productInfo.purchaseList];
			list[idx] = {
				...list[idx],
				url: urlValue,
			};
			setProductInfo({
				...productInfo,
				purchaseList: list,
			});
		} else if (e.target.name === "discount-code") {
			let list = [...productInfo.purchaseList];
			list[idx] = {
				...list[idx],
				discount_code: e.target.value,
			};
			setProductInfo({
				...productInfo,
				purchaseList: list,
			});
		} else {
			setProductInfo({
				...productInfo,
				[e.target.name]: e.target.value,
			});
		}
	};

	/**
	 * 적용하기/수정하기 버튼 클릭
	 */
	const onFinish = () => {
		let isValid = false;
		if (
			!productInfo.brand_name ||
			!productInfo.product_name ||
			!productInfo.img_type
		) {
			isValid = true;
		}
		let purchaseList = productInfo?.purchaseList;
		for (let i = 0; i < purchaseList; i++) {
			if (purchaseList[i]?.url) {
				if (!purchaseList[i].type) isValid = true;
			} else if (purchaseList[i].type) {
				if (!purchaseList[i].url) isValid = true;
			}
		}

		if (isValid) {
			toastAlert("상품 정보를 정확하게 입력해주세요.");
		} else {
			setIsLoading(true);
			let list = [];
			for (let i = 0; i < productInfo.purchaseList.length; i++) {
				let linkId = productInfo.purchaseList[i]?.id ?? null;
				if (productInfo.purchaseList[i].url) {
					let httpsUrl = productInfo.purchaseList[i].url.includes("http")
						? productInfo.purchaseList[i].url
						: "https://" + productInfo.purchaseList[i].url;
					let listEach = {
						platform_id: productInfo.purchaseList[i].type,
						platform_name:
							platformName[Number(productInfo.purchaseList[i].type) - 1] ??
							null,
						url: httpsUrl,
						discount_code: productInfo.purchaseList[i].discount_code ?? null,
					};

					if (linkId !== null) {
						listEach = { ...listEach, id: linkId };
					}
					list.push(listEach);
				}
			}
			let biggestIdObj = productList?.length
				? productList.reduce((prev, value) => {
						return prev.id >= value.id ? prev : value;
				  })
				: {};
			// let tempId = biggestIdObj?.id;
			let param = {
				// id: tempId ? tempId + 1 : 1,
				// 추천 영양제 sorting하기 위한 키 생성
				product_brand_name_key: `${productInfo.brand_name}-${productInfo.product_name}`,
				influencer_id: user.id,
				category_id: productInfo.category_id,
				category_name:
					level === "ingredient" ? categoryName : productInfo?.category_name,
				brand_name: productInfo.brand_name,
				product_name: productInfo.product_name,
				sub_title: productInfo.sub_title,
				description1: productInfo.descriptionList[0] ?? "",
				description2: productInfo.descriptionList[1] ?? "",
				description3: productInfo.descriptionList[2] ?? "",
				description4: productInfo.descriptionList[3] ?? "",
				description5: productInfo.descriptionList[4] ?? "",
				description6: productInfo.descriptionList[5] ?? "",
				search_tag: productInfo.search_tag,
				img_type: productInfo.img_type,
				created_by: user.id,
				purchaseLinkList: list,
				front_img_src: productInfo?.front_img_src,
				photo: productInfo?.photo,
				sort_order: productList?.length + 1,
				product_master_id: productInfo?.product_master_id,
			};
			if (productInfo.id) {
				param = {
					...param,
					id: productInfo.id,
				};
			}
			if (type === "edit" && selectProduct.id) {
				param = {
					...param,
					updated_by: user.id,
					id: selectProduct.id,
				};
			}

			let products = productList ? [...productList] : [];
			if (type === "edit") {
				products[index] = param;
			} else {
				products.push(param);
			}
			setProductList(products);
			setModalShow(false);
			setIsLoading(false);
			setProductInfo({
				category_id:
					level === "ingredient"
						? selectKey?.ingredient_id
						: selectProduct?.category_id,
				category_name:
					level === "ingredient"
						? selectKey?.ingredient_name
						: selectProduct?.category_name,
				brand_name: "",
				product_name: "",
				sub_title: "",
				descriptionList: [],
				purchaseList: [
					{
						type: "",
						url: "",
						discount_code: "",
					},
					{
						type: "",
						url: "",
						discount_code: "",
					},
				], // type, url, discount_code
				search_tag: "",
				img_type: null,
			});
			setImgSrc("/assets/images/channel/img-add.png");
		}
	};

	/**
	 * 프론트 내 업로드 버튼 클릭
	 */
	const onUploadImageClick = () => {
		if (!inputRef.current) {
			return;
		}
		inputRef.current.click();
	};

	/**
	 * 프론트 내 업로드 진행
	 * @param e
	 */
	const onUploadImage = (e) => {
		if (!e.target.files) {
			return;
		}
		const fileList = e.target.files[0];
		const url = URL?.createObjectURL(fileList);
		let photoInfo = {
			file: fileList,
			source: url,
			type: fileList.type,
		};
		setProductInfo({
			...productInfo,
			img_type: photoInfo.type?.split("/")[1],
			front_img_src: photoInfo.source,
			photo: photoInfo,
		});
		setImgSrc(photoInfo.source);
		// setPhoto(photoInfo);
	};

	/**
	 * 조합별 상품 등록 시 성분별 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const readCombinationProductList = async () => {
		setIsLoading(true);
		let param = {
			influencerId: user.id,
		};

		const res = await partnersApi.readCategoryList(param);
		if (res.code === 200) {
			setIngredientList(res.result.totalIngredientList);
		}
		setIsLoading(false);
	};

	return (
		<Modal
			title={`${type === "add" ? "상품 등록" : "상품 수정"}`}
			wrapClassName="edit-channel-modal"
			open={modalShow}
			centered={true}
			onCancel={() => setModalShow(!modalShow)}
			width="80%"
			footer={
				<Button
					className={`ant-btn-primary`}
					onClick={onFinish}
					loading={isLoading}
				>
					<span className={`finish`}>
						{type === "add" ? "등록하기" : "수정하기"}
					</span>
				</Button>
			}
		>
			{/* 상품 불러오기 */}
			{level === "ingredient" && (
				<div className={`add-modal-body-each-border`}>
					<div
						className={`add-modal-body-each-border-label`}
						style={{
							border: "none",
						}}
					>
						<p>상품 불러오기</p>
						<a
							className={`add-import-button`}
							onClick={() => {
								setImportShow(true);
							}}
						>
							<img
								src={`/assets/images/products/add-blue.png`}
								alt={`상품 불러오기`}
								style={{
									width: 13,
									height: 13,
								}}
							/>
							상품 불러오기
						</a>
					</div>
				</div>
			)}

			{/* 상품 정보 */}
			<div className={`add-modal-body-each-border`}>
				<div className={`add-modal-body-each-border-label`}>
					<p>상품 정보</p>
				</div>
				<div className={`add-modal-body-each-border-body`}>
					<Form
						layout={`horizontal`}
						labelCol={{ span: 4 }}
						wrapperCol={{ span: 10 }}
						autoComplete="off"
					>
						{/* 카테고리 */}
						<Form.Item
							label={`카테고리`}
							labelAlign="left"
							colon={false}
							name={`ingredients-name`}
						>
							{/* 조합별 카테고리 선택 */}
							{level === "combination" ? (
								<Dropdown
									overlay={dropdownCategory}
									trigger={["click"]}
									overlayStyle={{
										maxHeight: "20em",
										border: "solid 1px #ced4da",
										overflow: "auto",
									}}
								>
									<Button
										style={{
											display: "flex",
											alignItems: "center",
											gap: "3px",
										}}
										loading={isLoading}
									>
										{productInfo.category_name
											? productInfo.category_name
											: "카테고리명"}
										<img
											src={`/assets/images/report/report-search-date-icon-down.png`}
											alt={`드롭다운`}
											style={{
												height: "auto",
												width: "0.8em",
											}}
										/>
									</Button>
								</Dropdown>
							) : (
								<Input
									type={`text`}
									name={`category_name`}
									// className={`ingredient-name`}
									value={
										level === "ingredient"
											? categoryName
											: productInfo.category_name
									}
									initialvalues={
										level === "ingredient"
											? categoryName
											: productInfo.category_name
									}
									onChange={handleForm}
									placeholder={
										level === "ingredient" ? categoryName : `ex) 비타민 B군`
									}
									disabled={level === "ingredient"}
								/>
							)}
						</Form.Item>

						{/* 상품명 */}
						<Form.Item label="상품명" labelAlign="left" colon={false}>
							{level === "combination" ? (
								<Dropdown
									overlay={dropdownProduct}
									trigger={["click"]}
									overlayStyle={{
										maxHeight: "20em",
										border: "solid 1px #ced4da",
										overflow: "auto",
									}}
								>
									<Button
										style={{
											display: "flex",
											alignItems: "center",
											gap: "3px",
										}}
										loading={isLoading}
									>
										{productInfo.product_name
											? productInfo.product_name
											: "상품명"}
										<img
											src={`/assets/images/report/report-search-date-icon-down.png`}
											alt={`드롭다운`}
											style={{
												height: "auto",
												width: "0.8em",
											}}
										/>
									</Button>
								</Dropdown>
							) : (
								<Input
									type={`text`}
									name={`product_name`}
									value={productInfo.product_name}
									onChange={handleForm}
									placeholder={`상품명을 입력해주세요`}
									disabled={!!productInfo?.product_master_id}
								/>
							)}
						</Form.Item>

						{/* 브랜드명 */}
						<Form.Item label="브랜드명" labelAlign="left" colon={false}>
							<Input
								type={`text`}
								name={`brand_name`}
								value={productInfo.brand_name}
								onChange={handleForm}
								placeholder={`브랜드명을 입력해주세요`}
								disabled={
									level === "combination" || !!productInfo?.product_master_id
								}
							/>
						</Form.Item>

						{/* 상품 이미지 */}
						<Form.Item label="상품 이미지" labelAlign="left" colon={false}>
							<button
								className={`edit-profile`}
								style={{ padding: 0 }}
								onClick={onUploadImageClick}
								disabled={
									level === "combination" || !!productInfo?.product_master_id
								}
							>
								<input
									type="file"
									accept="image/*"
									style={{
										display: "none",
									}}
									ref={inputRef}
									onChange={onUploadImage}
									disabled={level === "combination"}
								/>
								<img
									src={`${imgSrc}`}
									// src={`/assets/images/channel/doctor.png`}
									onError={({ currentTarget }) => {
										currentTarget.onerror = null; // prevents looping
										// currentTarget.style.display = "none";
										currentTarget.src = `/assets/images/channel/img-add.png`;
									}}
									alt={`상품 이미지`}
									style={{
										width: "10em",
										height: "10em",
										borderRadius: "8px",
										objectFit: "cover",
									}}
								/>
								{type !== "add" && (
									<div
										style={{
											position: "absolute",
											background: "rgba(0,0,0,0.4)",
											width: "10em",
											height: "10em",
											top: 0,
											left: 0,
											right: 0,
										}}
									>
										<img
											src={`/assets/images/channel/white-close.png`}
											alt={`white-close`}
											className={`photo-img`}
											style={{
												top: "0.5em",
												right: "0.5em",
												width: "1.5em",
												height: "1.5em",
											}}
										/>
									</div>
								)}
							</button>
							<p
								style={{
									color: "#adb5bd",
									fontSize: "0.9em",
									margin: 0,
									paddingTop: "0.5em",
								}}
							>
								*권장 이미지 : 500 x 500px
							</p>
						</Form.Item>

						{/* 상품 설명 */}
						<Form.Item label="상품 설명" labelAlign="left" colon={false}>
							<Input
								type={`text`}
								name={`sub_title`}
								value={productInfo.sub_title}
								onChange={handleForm}
								placeholder={`상품 설명을 입력해주세요`}
								disabled={
									level === "combination" || !!productInfo?.product_master_id
								}
							/>
						</Form.Item>
					</Form>

					<Form
						layout={`horizontal`}
						labelCol={{ span: 4 }}
						wrapperCol={{ span: 20 }}
						autoComplete="off"
					>
						{/* 상품 특징 */}
						<Form.Item
							label={
								<div>
									상품 특징{"\n"}
									<span
										style={{
											color: "#adb5bd",
											fontSize: "0.9em",
										}}
									>
										*최대 6개
									</span>
								</div>
							}
							labelAlign="left"
							colon={false}
							className={`feature-wrap`}
						>
							{Array.from({ length: 6 }).map((arr, idx) => (
								<Form.Item
									label={`특징 0${idx + 1}`}
									labelAlign="left"
									colon={false}
									key={`특징 0${idx + 1}`}
									className={`feature-list`}
								>
									<Input
										type={`text`}
										name={`description`}
										placeholder={`상품의 특징을 입력해주세요`}
										value={productInfo.descriptionList[idx]}
										onChange={(e) => handleForm(e, idx)}
										disabled={
											level === "combination" ||
											!!productInfo?.product_master_id
										}
									/>
								</Form.Item>
							))}
						</Form.Item>
					</Form>
				</div>
			</div>

			{/* 구매경로 설정 */}
			<div className={`add-modal-body-each-border`}>
				<div className={`add-modal-body-each-border-label`}>
					<p>구매경로 설정</p>
					<p style={{ fontWeight: 400, color: "#117ffa" }}>
						상품링크에서 링크를 생성하셨나요? 링크 생성시 커미션율이 적용됩니다.
					</p>
				</div>
				<div className={`add-modal-body-each-border-body`}>
					<Form
						layout={`horizontal`}
						labelCol={{ span: 4 }}
						wrapperCol={{ span: 20 }}
						autoComplete="off"
					>
						{/* 구매 링크 */}
						<Form.Item label={`구매 링크`} labelAlign="left" colon={false}>
							{Array.from({ length: 2 }).map((arr, idx) => (
								<Form.Item
									label={`링크 0${idx + 1}`}
									labelAlign="left"
									colon={false}
									key={`링크 0${idx + 1}`}
									className={`feature-list`}
								>
									<Input
										type={`text`}
										name={`link-url`}
										value={
											productInfo?.purchaseList?.[idx]?.url
												? productInfo.purchaseList[idx].url?.includes("//")
													? productInfo.purchaseList[idx].url?.split("//")[1]
													: productInfo.purchaseList[idx].url
												: ""
										}
										onChange={(e) => handleForm(e, idx)}
										addonBefore="https://"
										style={{
											marginBottom: "0.5em",
										}}
										className={`link-input`}
										disabled={
											level === "combination" ||
											!!productInfo?.product_master_id
										}
									/>
									<Radio.Group
										className={`link-radio-group`}
										name={`link-type`}
										onChange={(e) => handleForm(e, idx)}
										value={
											productInfo?.purchaseList?.[idx]
												? String(productInfo.purchaseList[idx]?.type)
												: ""
										}
									>
										<Radio
											value="4"
											disabled={
												level === "combination" ||
												!!productInfo?.product_master_id
											}
										>
											당신의 영양제
										</Radio>
										<Radio
											value="2"
											disabled={
												level === "combination" ||
												!!productInfo?.product_master_id
											}
										>
											쿠팡
										</Radio>
										<Radio
											value="1"
											disabled={
												level === "combination" ||
												!!productInfo?.product_master_id
											}
										>
											iHerb
										</Radio>
										<Radio
											value="3"
											disabled={
												level === "combination" ||
												!!productInfo?.product_master_id
											}
										>
											셀로맥스
										</Radio>
									</Radio.Group>
									{/* 할인 코드 */}
									<Form.Item
										label={`할인 코드`}
										labelAlign="left"
										colon={false}
										style={{ paddingTop: "0.5em" }}
									>
										<Space direction="horizontal" align={"center"}>
											<Input
												type={`text`}
												name={`discount-code`}
												value={
													productInfo?.purchaseList?.[idx]
														? productInfo.purchaseList[idx]?.discount_code
														: ""
												}
												onChange={(e) => handleForm(e, idx)}
												disabled={
													level === "combination" ||
													!!productInfo?.product_master_id
												}
											/>
											{/*<Radio value="dangyoung">*/}
											{/*    기존 할인 코드와 동일*/}
											{/*</Radio>*/}
										</Space>
									</Form.Item>
								</Form.Item>
							))}
						</Form.Item>
					</Form>
					{/*<Form*/}
					{/*    layout={`horizontal`}*/}
					{/*    labelCol={{span: 5}}*/}
					{/*    wrapperCol={{span: 19}}*/}
					{/*    autoComplete="off"*/}
					{/*>*/}

					{/*</Form>*/}

					{/* 검색 태그 */}
					<Form
						layout={`horizontal`}
						labelCol={{ span: 5 }}
						wrapperCol={{ span: 19 }}
						autoComplete="off"
					>
						<Form.Item label={"검색 태그"} labelAlign="left" colon={false}>
							<Input
								type={`text`}
								name={`search_tag`}
								value={productInfo.search_tag}
								onChange={(e) => handleForm(e)}
								placeholder={`EX) 피로, 피로회복, 피로감, 피로할 때, 피로 영양제`}
								disabled={
									level === "combination" || !!productInfo?.product_master_id
								}
							/>
							<p style={{ paddingTop: "0.5em", color: "#868e96" }}>
								"," 로 구분하여 입력해주세요. EX) 피로, 피로회복, 피로감, 피로할
								때, 피로 영양제..
							</p>
						</Form.Item>
					</Form>
				</div>
			</div>

			{/* 상품 불러오기 */}
			{importShow && (
				<AddImportProductModal
					importShow={importShow}
					setImportShow={setImportShow}
					setImgSrc={setImgSrc}
					setProductInfo={setProductInfo}
				/>
			)}
		</Modal>
	);
};
export default AddProductModal;
